import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./swiper.css";
import Cards from "../card";

// import "./styles.css";

// import required modules
import { Autoplay, Navigation } from "swiper/modules";

const SwiperComp = ({ achivements }) => {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Navigation]}
        // modules={[Navigation]}
        className="mySwiper"
      >
        {achivements.map((value) => (
          <SwiperSlide>
            {/* <Cards url={value.url} desc={value.desc} width="50%" height="450" /> */}
            <Card
              sx={{
                width: { xs: "100%", md: "50%" },
                // height: 450,
                position: "relative",
              }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  // height={450}
                  image={value.url}
                  alt="green iguana"
                  className="image-zoom"
                />
              </CardActionArea>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default SwiperComp;
